import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import apiClient from "common/src/api/ApiClient";
import {browserTimeZone, dateToString} from "common/src/utils/DateUtils";

const processedSiteDataAPI = createSlice({
  name: 'siteData',
  initialState: {
    list: [],
    locationsList: [],
    locations: {},
    metadata: [],
    loading: false,
    error: null
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchSites.pending, (state, action) => {
      state.data = [];
      state.loading = true;
    })
    .addCase(fetchSites.fulfilled, (state, action) => {
      state.data = action.payload.payload;
      state.list = action.payload.payload;
      state.locationsList = action.payload.payload;
      state.locations = action.payload.payload.reduce((acc, item) => {
        acc[item.locationId] = item;
        return acc;
      }, {});
      state.loading = false;
    })
   .addCase(fetchSiteDirectionsMetadata.fulfilled, (state, action) => {
      state.metadata = action.payload.payload;
      state.meta = action.payload.payload.reduce((acc, item) => {
        if (!acc[item.locationId]) {
          acc[item.locationId] = [item];
        } else {
          acc[item.locationId] = [...acc[item.locationId], item];
        }
        return acc;
      }, {});
      state.loading = false;
    })
    .addCase(fetchSites.rejected, (state, action) => {
      // state.data = [];
      // state.list = [];
      // state.locationsList = [];
      state.loading = false;
      state.error = action["error"];
    })
  }
});

export const fetchSites = createAsyncThunk(
  "data/fetch/siteLocations",
  async () => {
    const response = await apiClient.get(`/api/v1/processed/site-data/siteLocations`);
    return response.data
  }
);

export const fetchSiteDirectionsMetadata = createAsyncThunk(
  "data/fetch/site-meta",
  async ({from, to}, thunkApi) => {
    // normalize inputs
    const params = {};
    if (from) params.from = dateToString(from, true, false);
    if (to) params.to = dateToString(to, true, false);

    const queryParts = [`timeZone=${encodeURIComponent(browserTimeZone())}`];
    if (params.from) queryParts.push(`from=${params.from}`);
    if (params.to) queryParts.push(`to=${params.to}`);
    const queryString = queryParts.length ? `?${queryParts.join("&")}` : "";
    const fullUrl = `/api/v1/processed/site-data/site-meta${queryString}`;
    const response = await apiClient.get(fullUrl);
    return response.data
  }
);

export default processedSiteDataAPI.reducer;
